<template>
    <v-main>
        <v-container class="text-center">
            <i class="fas fa-3x fa-lock"></i>
             <h1>Restricted</h1>
        </v-container>

    </v-main>
</template>

<script>
export default {
    name: 'Restricted'
}
</script>

